<template>
  <div class="main" id="tab" v-loading="tabLoading">
    <el-tabs type="border-card" v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="全局设置" name="global">
        <el-form :model="controlForm" label-width="200px" size="medium" v-loading="controlFormLoading">
          <el-scrollbar>
            <el-form-item label="小票显示企业名">
              <div class="tips">
                <el-input placeholder="请输入内容" v-model="controlForm.enterpriseName"></el-input>
                <div class="el-form-item__error">
                 默认与注册企业名一致，可以修改
                </div>
              </div>
            </el-form-item>
            <el-form-item label="小票显示备注">
              <div class="tips">
                <el-input type="textarea" autosize placeholder="请输入内容" v-model="controlForm.remark" class="textarea"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="小票显示监督电话">
              <div class="tips">
                <el-input type="textarea" autosize placeholder="请输入内容" v-model.number="controlForm.bossPhone" maxlength="11" class="textarea"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="打印机规格">
              <el-select style="margin-right: 12px;" v-model="controlForm.pageSet" placeholder="请选打印机规格" value-key="value">
                <el-option
                  v-for="item in pageSetList"
                  :key="item.value"
                  :label="item.text"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公章图片">
              <el-upload action="#" list-type="picture-card" class="product-demo" :auto-upload="false" :limit="1" :on-change="handleProductChange" ref="productUpload">
                  <div v-if="!file.upload" @click.stop>
                      <div class="el-upload-list__item-thumbnail" v-if="!file.url" style="border: 1px solid #d7dae2;text-align: center; line-height: 148px;">图片</div>
                      <div slot="file" slot-scope="{file}">
                          <el-image class="el-upload-list__item-thumbnail" :src="file.url" alt="" fit="cover"></el-image>
                      </div>
                  </div>
                  <el-image @click.stop v-else class="el-upload-list__item-thumbnail box1" :src="file.upload" alt="" fit="cover"></el-image>
                  <div class="product-btn" slot="default">
                      <el-button v-if="!file.url && !file.upload" size="small">选择图片</el-button>
                      <el-button v-else size="small" @click.stop="handleProductPreview">预览图片</el-button>
                      <el-button @click.stop="handleProductRemove" icon="el-icon-delete" type="text" size="small" style="font-size: 14px; padding: 8px 12px; margin-left: -6px;">删除</el-button>
                  </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="是否隐藏卸货清单提示语">
              <el-switch v-model="controlForm.shopNoteIsShow" active-text="是" inactive-text="否" active-value="Y" inactive-value="N"></el-switch>
            </el-form-item>
            <el-form-item label="是否隐藏商品间隔虚线">
              <el-switch v-model="controlForm.itemDashedIsShow" active-text="是" inactive-text="否" active-value="Y" inactive-value="N"></el-switch>
            </el-form-item>
            <el-form-item label="退货原因商品打印主商品名">
              <el-switch v-model="controlForm.isShowMasterNameIsShow" active-text="是" inactive-text="否" active-value="Y" inactive-value="N"></el-switch>
            </el-form-item>
            <el-form-item label="手机端隐藏“打印条形码”">
              <el-switch v-model="controlForm.isShowPrintBarcodeIsShow" active-text="是" inactive-text="否" active-value="Y" inactive-value="N"></el-switch>
            </el-form-item>
            <el-form-item>
              <p style="text-align: center; transform: translateX(-100px);"><el-button type="primary" @click="saveSet">保存设置</el-button></p>
            </el-form-item>
          </el-scrollbar>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="模板设置" name="template" lazy>
        <el-container>
          <el-main>
            <div class="mainTable">
              <el-card shadow="never">
                <div>
                  <span>单据类型：</span>
                  <el-select style="width: 140px; margin: 0 10px;" size="medium" v-model="templateForm.printSetType" value-key="value" placeholder="请选择单据类型" @change="getPrintTemplateList">
                    <el-option
                      v-for="item in printSetTypeList"
                      :key="item.value"
                      :label="item.text"
                      :value="item">
                    </el-option>
                  </el-select>
                  <span>打印模板：</span>
                  <el-select style="width: 140px; margin: 0 10px;" size="medium" v-model="templateForm.printTemplate" value-key="value" placeholder="请选择打印模板" @change="printSetTypeChange">
                    <el-option
                      v-for="item in printTemplateList"
                      :key="item.value"
                      :label="item.text"
                      :value="item">
                    </el-option>
                  </el-select>
                  <el-button size="medium" type="success" @click="showPrintTemplate">添加模板</el-button>
                  <el-button size="medium" @click="getRelationSalesman">关联业务</el-button>
                </div>
                <div style="margin-top: 6px;">
                  <el-radio-group v-model="templateForm.isStandardPrint" @change="standardPrintChange">
                    <el-radio label="Y">标准版</el-radio>
                    <el-radio label="N">简洁版</el-radio>
                  </el-radio-group>
                  <el-button size="medium" type="primary" @click="saveSet">保存设置</el-button>
                </div>
              </el-card>
              <div class="table" v-loading="tableLoading">
                <el-table ref="uxGrid" size="mini" :data="tableList" height="100%" max-height="100%" border stripe keep-source :highlightCurrentRow="false" :edit-config="{trigger: 'click', mode: 'cell'}" show-overflow="title">
                  <el-table-column type="index" width="50" label="序号"></el-table-column>
                  <el-table-column field="printFieldName" label="字段名称" width="180">
                    <template v-slot="{ row }">{{ row['printFieldName'] }}</template>
                  </el-table-column>
                  <el-table-column field="isShow" label="是否显示" width="110">
                    <template v-slot="{ row }">
                      <!-- isOptional Y 可选 -->
                      <span v-if="row.isOptional == 'N'">--</span>
                      <el-switch v-else v-model="row.isShow" :disabled="templateForm.isStandardPrint == 'N'" active-text="是" inactive-text="否" active-value="Y" inactive-value="N" @change="switchChange($event, row)"></el-switch>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="preview" :style="{width: 80 * 3.77 + 'px'}">
              <print-template ref="printTemplates" :type="templateForm.printSetType.value" :template-id="this.templateForm.printTemplate.value" :print-data="printTemplateObj" :enterpriseName="controlForm.enterpriseName" :remark="controlForm.remark"></print-template>
            </div>
          </el-main>
        </el-container>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="关联业务" :visible.sync="dialogTableVisible" custom-class="relationSalesmanDialog" v-loading="dialogLoading" @closed="dialogClocse">
      <div class="product-form">
        <div class="transfer-left">
          <div class="transfer-head">
            <p style="font-weight: 700; font-size: 14px;">可对应业务</p>
            <p style="color: #409EFF; cursor: pointer;" @click="handleLeftAllChange">全部对应</p>
            <p style="color: #909399;">{{leftList.length}}</p>
          </div>
          <div class="transfer-body">
            <div class="transfer-label" v-for="(item, index) in leftList" :key="index" @click="handleLeftChange(index)">
              <p style="font-size: 14px;">{{item.text}}</p>
              <el-button icon="el-icon-right" type="text" size="mini"></el-button>
            </div>
          </div>
        </div>
        <div class="transfer-right">
            <div class="transfer-head">
              <p style="font-weight: 700; font-size: 14px;">已对应业务</p>
              <p style="color: #409EFF; cursor: pointer;" @click="handleRightAllChange">取消全部对应</p>
              <p style="color: #909399;">{{rightList.length}}</p>
            </div>
            <div class="transfer-body">
              <div class="transfer-label" v-for="(item, index) in rightList" :key="index" @click="handleRightChange(index)">
                <p style="font-size: 14px;">{{item.text}}</p>
                <el-button icon="el-icon-back" type="text" size="mini"></el-button>
              </div>
            </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="relationSalesman">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog width="400px" class="img-dialog" :visible.sync="imgVisible">
        <img width="100%" :src="file.thumb" alt="">
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="addTemplateDialogVisible"
      custom-class="messageDialog"
      @close="addTemplateDialogClose"
      width="420px">
      <el-form ref="addTemplateForm" :model="addTemplateForm" :rules="{ name: [{ required: true, message: '模板名称格式不能为空', trigger: 'change' },] }" label-position="top">
        <el-form-item label="请输入模板名称" prop="name">
          <el-input v-model="addTemplateForm.name"></el-input>
        </el-form-item>
        <!-- 一、老账号（接口1 isPrintNewModel == 'N'）
            （1）数据库有模板，有前端写死模板时（接口2 isNew == 'N'）
            会让选择新增哪个版本的模板，第一版是前端写死的打印，第二版是存到数据库的模板，	每种单据类型唯一
            （2）数据库有模板，没有前端写死模板时
            新增直接默认第二版，不让选择版本
            二、新开账号
            新增直接默认第二版，不让选择版本 -->
        <!-- <el-form-item label="请选择版本" v-if="controlForm.isPrintNewModel == 'N' && templateForm.printSetType.isNew == 'N'">
          <el-radio-group label="请选择版本" v-model="addTemplateForm.radio">
            <el-radio :label="1">第一版</el-radio>
            <el-radio :label="2">第二版</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <!-- 一、老账号
        （1）数据库有模板，有前端写死模板时
        会让选择新增哪个版本的模板，第一版是前端写死的打印，数据库中当前类型下有几个就展示几个
        （2）数据库有模板，没有前端写死模板时
        不展示第一版，其余与（1）相同
        二、新账号
        不展示第一版，其余与一（1）相同 -->
        <el-form-item label="请选择版本" v-if="(controlForm.isPrintNewModel == 'N' && templateForm.printSetType.isNew == 'N') || (templateForm.printSetType.modelList && templateForm.printSetType.modelList.length > 1)">
          <el-radio-group label="请选择版本" v-model="addTemplateForm.radio">
            <el-radio :label="0" v-if="controlForm.isPrintNewModel == 'N' && templateForm.printSetType.isNew == 'N'">第一版</el-radio>
            <el-radio v-for="item in templateForm.printSetType.modelList" :key="item.id" :label="item.id">{{ item.modelName }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="addTemplateCancel">取 消</el-button>
        <el-button size="small" type="primary" @click="addTemplateConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { titleCase } from '@/assets/js/common.js'
import printTemplate from '@/components/print/printTemplate.vue'
export default {
  components: {
    printTemplate
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').onfocus = function (e) {
          e.currentTarget.select()
        }
        el.querySelector('input').focus()
      }
    }
  },
  data() {
    return {
      tabLoading: false,
      activeName: 'global',
      controlFormLoading: false,
      controlForm: {
        enterpriseName: '', // 小票显示企业名
        remark: '', // 小票显示备注
        bossPhone: '',
        pageSet: { value: '80', text: '80mm' }, // 打印机规格
        /**
        兼容模式：
        1、如果有旧版有新版，那么只有明确设置了打印模板是第二版了，才会使用新版打印。
        2、如果只有新版，没有旧版，那么直接使用新版。
        新版模式：
        1、只有新版打印了。不再显示旧版打印。
        */
        isPrintNewModel: 'N', // PC端是否启用新模型  Y: 新版  N: 兼容模式
        shopNoteIsShow: 'N',
        itemDashedIsShow: 'N',
        isShowMasterNameIsShow: 'N',
        isShowPrintBarcodeIsShow: 'N'
      },
      templateForm: {
        printSetType: {},
        // printSetType: {value: 'XSD', text: '销售单', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']] },
        isStandardPrint: 'Y',
        printTemplate: {}
      },
      pageSetList: [
        {value: '80', text: '80mm'},
        {value: '58', text: '58mm'},
      ],
      printSetTypeList: [
        // {value: 'XSD', text: '销售单', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']] },
        // {value: 'XSY', text: '销售订单', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']] },
        // {value: 'XST', text: '销售退货单', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']] },
        // {value: 'XTY', text: '退货订单', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']] },
        // {value: 'HHD', text: '还货单', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']] },
        // {value: 'HDD', text: '还货订单', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']] },
        // {value: 'CINV', text: '库存情况', version: 2 },
        // // {value: 'DAILY', text: '日报', mutex: [['visitPrintHeadResponsesIsShow', 'oldDailyIsShow']]},
        // {value: 'DAILY', text: '日报', version: 2 },
        // {value: 'DBD', text: '调拨单', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']] },
        // {value: 'CXD', text: '车销单', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']] },
        // {value: 'CHD', text: '换货单', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']] },
        // {value: 'CHDD', text: '换货订单', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']] },
        // {value: 'DHD', text: '订货单', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']] },
        // {value: 'PKD', text: '盘点单', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']]},
        // {value: 'DXDH', text: '拜访分析', version: 2 },
        // {value: 'DXD', text: '拜访明细', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']] },
        // {value: 'CGD', text: '采购进货', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']] },
        // {value: 'CGT', text: '采购退货', version: 2, mutex: [['invQtyFormatIsShow', 'billQtyFormatIsShow']] },
        // {value: 'XSIHZ', text: '销售汇总', version: 2 },
      ],
      
      tableLoading: false,
      tableList: [],
      printTemplateObj: {},
      printTemplateList: [],
      dialogTableVisible: false,
      dialogLoading: false,
      leftList: [],
      rightList: [],
      file: {
          url: '',
          thumb: '',
          upload: ''
      },
      imgVisible: false,
      imgUrl: '',

      addTemplateDialogVisible: false,
      addTemplateForm: {
        name: '',
        radio: 0
      },
    }
  },
  created() {
    this.getPrintHeadTemplate()
  },
  watch: {
    'templateForm.printSetType'({ isNew }) {
      console.log(this.templateForm);
      if (isNew == 'N' && this.controlForm.isPrintNewModel == 'N') {
        this.addTemplateForm.radio = 0
      } else {
        try {
          if (this.templateForm.printSetType && this.templateForm.printSetType.modelList && this.templateForm.printSetType.modelList.length) {
            this.addTemplateForm.radio = this.templateForm.printSetType.modelList[0].id
          }
        } catch (error) {
          this.addTemplateForm.radio = 1
          console.log("🚀 ~ error:", error)
        }
      }
    }
  },
  computed: {
    printSetType() {
      return this.activeName == 'global' ? { value: 'PUBLIC', text: '公共参数' } : this.templateForm.printSetType
    },
  },
  methods: {
    async getPrintSetTypeList() {
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/print/selectPrintNewModelList.html')
      if (res.code != '0') return this.$alert(res.message, '提示', {
        confirmButtonText: '确定'
      })
      this.printSetTypeList = res.data
      this.templateForm.printSetType = res.data[0]
      this.getPrintTemplateList()
    },
    async getPrintTemplateList() {
      this.tabLoading = true
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/print/selectPrintTemplateList.html', {
        printSetType: this.printSetType.value
      })
      this.tabLoading = false
      if (res.code != '0') return this.$alert(res.message, '提示', {
        confirmButtonText: '确定'
      })
      this.printTemplateList = res.data
      this.$nextTick(() => {
        if (this.printTemplateList[0]) {
          this.templateForm.printTemplate = this.printTemplateList[0]
          this.printSetTypeChange()
        } else {
          this.templateForm.printTemplate = {}
          this.tableList = []
          this.printTemplateObj = {}
          this.$nextTick(() => {
            this.$refs.printTemplates.updataData()
          })
        }
      })
    },
    handleTabClick() {
      if (this.activeName == 'global') {
        this.templateForm.isStandardPrint = 'Y'
        this.templateForm.printTemplate = {}
        this.getPrintHeadTemplate()
      } else {
        this.getPrintSetTypeList()
      }
    },
    isPrintPageChange(val) {
      if (val == 'N') {
        this.controlForm.isPrintHead = false
        this.controlForm.isPrintFooter = false
      }
    },
    printSetTypeChange() {
      this.tableList = []
      this.printTemplateObj = {}
      this.getPrintTemplate()
      this.getPrintTemplateObj()
      this.$nextTick(() => {
        console.log(33333333);
        this.$refs.printTemplates.updataData()
      })
    },
    async getPrintHeadTemplate() {
      this.controlFormLoading = true
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/print/getUserMobilePrint.html', {
        printSetType: this.printSetType.value,
        id: this.templateForm.printTemplate.value
      })
      this.controlFormLoading = false
      if (res.code != '0') return this.$alert(res.message, '提示', {
        confirmButtonText: '确定'
      })
      this.controlForm = { ...this.controlForm, ...res.data }
      let pageSet = this.pageSetList.filter(i => i.value == res.data.printspecs)
      if (pageSet.length) {
        this.controlForm.pageSet = pageSet[0]
      } else {
        this.controlForm.pageSet = this.pageSetList[0]
      }
      this.handleProductRemove()
      if (res.data.url) {
          this.file.upload = res.data.url
          this.file.thumb = res.data.url
      }
      console.log(this.controlForm)
    },
    async getPrintTemplate(isChange = false) {
      this.tableLoading = true
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/print/selectCustPrintParamJsonList.html', {
        printSetType: this.printSetType.value,
        id: this.templateForm.printTemplate.value
      })
      this.tableLoading = false
      if (res.code != '0') return this.$alert(res.message, '提示', {
        confirmButtonText: '确定'
      })
      if (!isChange) {
        this.templateForm.isStandardPrint = res.data.isStandardPrint
      }
      this.tableList = res.data.schemaList
    },
    async getPrintTemplateObj() {
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/print/selectCustPrintParam.html', {
        printSetType: this.printSetType.value,
        id: this.templateForm.printTemplate.value
      })
      if (res.code != '0') return this.$alert(res.message, '提示', {
        confirmButtonText: '确定'
      })
      this.printTemplateObj = res.data
      let { mutex } = this.printSetType
      if (mutex && mutex.length) {
        mutex.forEach(row => {
          let index = this.tableList.findIndex(i => i.printFieldValue == row[0])
          if (index > -1) {
            this.switchChange(this.printTemplateObj[row[0]], this.tableList[index])
          }
        })
      }
    },
    async onSubmit(tag) {
      let params = {...this.templateForm}
      let tableList = []
      this.tableList.forEach(item => {
        tableList = tableList.concat(item.children)
      })
      params.detailStr = JSON.stringify(tableList)
      delete params.pageSet
      const { data: res } = await this.$http.post('/Account/PrintSet/addPrintTemplate.html', this.Qs.stringify(params))
      if (!res.success) return this.$alert(res.msg, '提示', {
        confirmButtonText: '确定'
      })
      this.$message({
        type: 'success',
        message: res.msg
      });
      this.getPrintHeadTemplate()
      if (tag == 1) {
        window.open(`/Account/PrintSet/printDemo.html?printSetType=${params.printSetType}`,'_blank',"width=1011,height=680,left=300,top=150,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,location=no")
      }
    },
    switchChange(value, { printFieldValue }) {
      let { mutex } = this.printSetType
      if (mutex && mutex.length) {
        mutex.forEach(row => {
          if (row.includes(printFieldValue)) {
            row.forEach(item => {
              if (item != printFieldValue) {
                if (value == 'Y') {
                  this.$nextTick(() => {
                    let index = this.tableList.findIndex(i => i.printFieldValue == item)
                    if (index > -1) {
                      this.$set(this.tableList[index], 'isShow', 'N')
                    }
                  })
                  this.printTemplateObj[item] = 'N'
                } else if(value == 'N') {
                  this.$nextTick(() => {
                    let index = this.tableList.findIndex(i => i.printFieldValue == item)
                    this.$set(this.tableList[index], 'isShow', 'Y')
                  })
                  this.printTemplateObj[item] = 'Y'
                }
              }
            })
          }
        })
      }
      this.printTemplateObj[printFieldValue] = value
    },
    async saveSet() {
      if (!this.templateForm.printTemplate.value && this.activeName != 'global') {
        return this.$alert('请先选择打印模板', '提示', {
          confirmButtonText: '确定'
        })
      }
      if (this.file.url) {
          var formData = new FormData();
          delete this.file.url.uid
          formData.append("file", this.file.url);
          console.log(this.file.url)
          const { data: res } = await this.$http.post('/android/AcceptPictureServlet2', formData)
          console.log(res)
          if (res.code == 'ERROR') {
              return this.$message.error('图片上传错误')
          }
          this.imgUrl = res.result
          this.onSubmitInfo()
      } else {
          this.imgUrl = this.file.upload || ''
          this.onSubmitInfo()
      }
    },
    async onSubmitInfo() {
      let printTemplate = {}
      if (this.activeName == 'global') {
        printTemplate = { ...this.controlForm }
        printTemplate.printspecs = printTemplate.pageSet.value
        delete printTemplate.pageSet
      } else {
        this.tableList.forEach(item => {
          printTemplate[item['printFieldValue']] = item['isShow']
        })
      }
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/print/addMobilePrintNew.html', {
        printTemplate: JSON.stringify(printTemplate),
        printSetType: this.printSetType.value,
        printSetDesc: this.printSetType.text,
        isStandardPrint: this.templateForm.isStandardPrint,
        id: this.templateForm.printTemplate.value,
        url: this.imgUrl
      })
      if (res.code != '0') return this.$alert(res.message, '提示', {
        confirmButtonText: '确定'
      })
      this.$message({
        type: 'success',
        message: res.message
      });
      this.getPrintHeadTemplate()
    },
    async useDefaultTemplate() {
      const confirmResult = await this.$confirm('是否重置为默认模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') return this.$message.info('取消重置')
      const loading = this.$loading({
        lock: true,
        text: '重置中，请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let printSetType = this.templateForm.printSetType
      const { data: res } = await this.$http.post('/Account/PrintSet/resetPrintTemplate.html', this.Qs.stringify({printSetType, isNewPrint: 'Y'}))
      loading.close()
      if (!res.success) return this.$alert(res.msg, '提示', {
        confirmButtonText: '确定'
      })
      this.$message({
        type: 'success',
        message: res.msg
      });
      this.getPrintHeadTemplate()
    },
    standardPrintChange(val) {
      console.log(val)
      if (val == 'N') {
        this.tableList = this.tableList.map(item => {
          if (item.isOptional == 'Y') {
            item.isShow = 'N'
            this.printTemplateObj[item.printFieldValue] = 'N'
          }
          return item
        })
      } else {
        this.getPrintTemplate(true)
        this.getPrintTemplateObj()
      }
    },
    addTemplateCancel() {
      this.$refs.addTemplateForm.resetFields()
      this.addTemplateDialogVisible = false
    },
    addTemplateDialogClose() {
      this.addTemplateForm.radio = 0
    },
    async addPrintTemplate(loading, params) {
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/print/addMobilePrintTemplate.html', params)
      loading.close()
      if (res.code != 0) return this.$alert(res.message, '提示', {
        confirmButtonText: '确定'
      })
      this.$message({
        type: 'success',
        message: '添加成功'
      });
      this.$refs.addTemplateForm.resetFields()
      this.addTemplateDialogVisible = false
      this.getPrintTemplateList()
    },
    addTemplateConfirm() {
      this.$refs.addTemplateForm.validate((valid) => {
        if (valid) {
          let { name, radio } = this.addTemplateForm
          const loading = this.$loading({
            lock: true,
            text: '添加中，请耐心等待',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          if (radio == 0) {
              this.addPrintTemplate(loading, {
              printTemplateName: name,
              printSetType: this.printSetType.value,
              printSetDesc: this.printSetType.text,
            })
          } else {
              this.addPrintTemplate(loading, {
              printTemplateName: name,
              printSetType: this.printSetType.value,
              printSetDesc: this.printSetType.text,
              printModelId: radio
            })
          }
          // if (this.controlForm.isPrintNewModel == 'Y' || radio == 2) {
          //   this.$post('/erpnew/account/c/reada46ceb/print/selectNewPrintModelList.html', {
          //     printSetType: this.templateForm.printSetType.value,
          //   }).then(({ data: res }) => {
          //     if (res.code != '0') return this.$alert(res.message, '提示', {
          //       confirmButtonText: '确定'
          //     })
          //     let printShowModelID = ''
          //     if (res.data && res.data.length) {
          //       printShowModelID = res.data[0].id
          //     }
          //     this.addPrintTemplate(loading, {
          //       printTemplateName: name,
          //       printSetType: this.printSetType.value,
          //       printSetDesc: this.printSetType.text,
          //       printModelId: printShowModelID
          //     })
          //   })
          // } else {
          //   this.addPrintTemplate(loading, {
          //     printTemplateName: name,
          //     printSetType: this.printSetType.value,
          //     printSetDesc: this.printSetType.text,
          //   })
          // }
          
        } else {
          console.log('error submit!!');
          return false;
        }
      })
      
    },
    showPrintTemplate() {
      this.addTemplateDialogVisible = true
      this.$nextTick(() => {
        this.$refs.addTemplateForm.resetFields()
      })
    },
    async getRelationSalesman() {
      this.dialogTableVisible = true
      this.dialogLoading = true
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/print/selectBindTemplateUserList.html', {
        printSetType: this.printSetType.value,
        id: this.templateForm.printTemplate.value
      })
      this.dialogLoading = false
      let leftList = []
      let rightList = []
      res.data.forEach(item => {
        if (item.isShow == 'Y') {
          rightList.push(item)
        } else {
          leftList.push(item)
        }
      })
      this.leftList = leftList
      this.rightList = rightList
    },
    handleLeftAllChange() {
      if (this.leftList.length != 0) {
        this.rightList = this.rightList.concat(this.leftList);
        this.leftList = []
      }
    },
    handleRightAllChange() {
      if (this.rightList.length != 0) {
        this.leftList = this.leftList.concat(this.rightList);
        this.rightList = []
      }
    },
    handleLeftChange(index) {
      let item = this.leftList[index]
      this.rightList.push(item)
      this.leftList.splice(index, 1)
    },
    handleRightChange(index) {
      let item = this.rightList[index]
      this.leftList.push(item)
      this.rightList.splice(index, 1)
    },
    dialogClocse() {
      this.leftList = []
      this.rightList = []
    },
    async relationSalesman() {
      if (!this.templateForm.printTemplate.value) {
        return this.$alert('请先选择打印模板', '提示', {
          confirmButtonText: '确定'
        })
      }
      const loading = this.$loading({
        lock: true,
        text: '绑定中，请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/print/addMobileUserPrintTemplate.html', {
        printTemplateID: this.templateForm.printTemplate.value,
        printSetType: this.printSetType.value,
        printSetDesc: this.printSetType.text,
        id: this.rightList.map(i => i.value).join(',')
      })
      loading.close()
      if (res.code != 0) return this.$alert(res.message, '提示', {
        confirmButtonText: '确定'
      })
      this.$message({
        type: 'success',
        message: '添加成功'
      });
      this.dialogTableVisible = false
      // this.getPrintTemplateList()
    },
    //上传图片
    imagePreview(file) {
        var self = this;
        //定义一个文件阅读器
        var reader = new FileReader();
        //文件装载后将其显示在图片预览里
        reader.onload = function(e) {
            //将bade64位图片保存至数组里供上面图片显示
            self.file.thumb = e.target.result;
        };
        reader.readAsDataURL(file);
    },
    handleProductChange(file) {
        console.log(file)
        this.file.url = file.raw //图片的url
        this.imagePreview(this.file.url);
    },
    handleProductRemove() {
        this.file.url = '' //图片的url
        this.file.upload = ''
        this.file.thumb = ''
        this.$refs.productUpload.clearFiles();
    },
    handleProductPreview() {
        this.imgVisible = true
    },
  }
}
</script>

<style lang="less">
.messageDialog {
  padding-bottom: 10px;
  vertical-align: middle;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  text-align: left;
  overflow: hidden;
  backface-visibility: hidden;
  .el-dialog__header {
    position: relative;
    padding: 15px 15px 10px;
  }
  .el-dialog__body {
    padding: 10px 15px;
    color: #606266;
    font-size: 14px;
  }
  .el-dialog__footer {
    padding: 5px 15px 0;
    text-align: right;
  }
}
</style>

<style lang="less" scoped>

.main {
  height: 100%;
  ::v-deep .el-tabs {
    height: calc(100% - 2px);
    .el-tabs__content {
      height: calc(100% - 40px);
      box-sizing: border-box;
      .el-tab-pane,.el-container {
        height: 100%;
      }
    }
    .el-form {
      .el-form-item {
        margin-bottom: 12px;
        .tips {
          position: relative;
          height: 100%;
          margin-bottom: 16px;

          .textarea {
            .el-textarea__inner{
              min-height: 33px !important;
            }
          }
        }
        .append {
          margin: 0 6px;
        }
      }
    }
    #pane-global {
      .el-form {
        height: 100%;
      }
    }
    .el-scrollbar {
      height: 100%;
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
      .el-scrollbar__bar {
        z-index: 999;
      }
    }
    .el-aside {
      height: 100%;
      .templateForm {
        box-sizing: border-box;
        padding: 10px 6px;
        height: calc(100% - 2px);
        overflow: hidden;
        .el-form-item__label {
          line-height: 24px;
        }
      }
    }
    .el-main {
      height: 100%;
      padding: 0 12px;
      display: flex;
      overflow: hidden;
      .mainTable {
        height: 100%;
        .el-card {
          .el-card__body {
            padding: 6px;
            .el-radio {
              margin-right: 12px;
            }
          }
        }
        .table {
          height: calc(100% - 92px);
          .el-table__indent,
          .el-table__placeholder {
            display: none;
            padding: 0 !important;
          }
          .el-table {
            display: inline-block;
            min-width: 688px;
          }
        }
      }
      .preview {
        position: relative;
        width: calc(241px * 3.77);
        display: inline-block;
        margin-left: 12px;
        border: 1px solid #ccc;
        box-sizing: border-box;
        padding: 6px;
        overflow: auto;
      }
    }
  }
    ::v-deep .relationSalesmanDialog {
      min-width: 600px;
      .product-form{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      .transfer-left, .transfer-right{
          width: 48%;
          border: 1px solid #ebeef5;
          border-radius: 4px;
          overflow: hidden;
          background: #fff;
          display: inline-block;
          vertical-align: middle;
          box-sizing: border-box;
          position: relative;
      }
  
      .transfer-head{
          height: 40px;
          line-height: 40px;
          background: #f5f7fa;
          margin: 0;
          padding: 0 15px;
          border-bottom: 1px solid #ebeef5;
          box-sizing: border-box;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
      }
  
      .transfer-body{
          height: 300px;
          margin: 0;
          margin-bottom: -1px;
          list-style: none;
          overflow: auto;
          box-sizing: border-box;
          display: flex;
          flex-flow: column;
      }
  
      .transfer-body .transfer-label{
          line-height: 36px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 0 15px;
          border-bottom: 1px solid #ebeef5;
      }
      .transfer-body .transfer-label p{
        margin: 0;
      }
      .transfer-body .transfer-label .el-button--text{
        display: none;
      }
      .transfer-body .transfer-label:hover .el-button--text{
        display: inline-block;
      }
    }
}
/*上传图片*/
::v-deep .product-demo{
    width: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .el-upload-list__item-thumbnail{
        width: 148px;
        height: 148px;
        margin-bottom: 10px;
        border-radius: 4px;
    }
    .el-icon-delete{
        font-size: 14px;
        color: #409EFF
    }
    .el-upload.el-upload--picture-card{
        height: auto;
        border: none;
        background: transparent;
        line-height: 1;
    }
    .el-upload-list__item-actions{
        display: none;
    }
    .el-upload-list__item{
        transition: none;
        margin: 0;
    }

    .product-btn{
      display: flex;
      flex-direction: row;
      align-items: center;
    }
}
::v-deep .img-dialog {
  .el-dialog{
    background-color: transparent;
  }
  .el-dialog__header,
  .el-dialog__body{
      padding: 0;
  }
  .el-dialog__close{
      font-size: 16px;
      color: #fff;
  }
}
</style>